module.exports = [
  ...require('./itemGroups'),

  require('./list/matalotok'),
]
